import { Leaf, Clock3, Scale, Recycle, ChefHat, Truck } from 'lucide-react';

const VALUES = [
  { Icon: Clock3, title: 'Labour savings', body: 'Thaw, heat & serve — no skilled bakery staff, no scratch prep, no assembly line.' },
  { Icon: Scale, title: 'Consistent portions', body: 'Pre-portioned, spec-driven SKUs deliver the same plate and the same cost, every time.' },
  { Icon: Recycle, title: 'Reduced food waste', body: 'Frozen inventory means you prepare exactly what you sell — nothing over-proofed, nothing binned.' },
  { Icon: ChefHat, title: 'Easy preparation', body: 'Freezer to service in minutes with simple oven or microwave instructions any team can follow.' },
  { Icon: Truck, title: 'Dependable supply', body: 'Weekly refrigerated delivery across every Canadian province, with case-ready pallets.' },
  { Icon: Leaf, title: '100% plant-based', body: 'Zero dairy. Zero eggs. One product line covers more diners and simplifies allergen management.' },
];

export const Values = () => {
  return (
    <section className="relative py-24 md:py-32">
      <div className="container mx-auto">
        <div className="max-w-2xl">
          <div className="font-script text-2xl text-leaf">why operators love us</div>
          <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
            Built for institutional foodservice,<br/>
            <span className="italic font-light text-leaf">loved at the counter.</span>
          </h2>
          <p className="mt-5 text-muted-foreground text-base md:text-lg">
            We engineered every product around the operational realities of universities, hotels and
            institutional dining — labour, consistency, allergens and speed of service.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {VALUES.map(({ Icon, title, body }, i) => (
            <div key={title} className="group relative rounded-3xl bg-card border border-border/70 p-7 shadow-soft hover:shadow-card hover:-translate-y-1 transition-all duration-500">
              <div className="absolute top-0 left-7 -translate-y-1/2 h-12 w-12 rounded-2xl gradient-leaf grid place-items-center text-primary-foreground shadow-card">
                <Icon className="h-5 w-5" />
              </div>
              <div className="mt-6">
                <h3 className="font-display text-xl font-semibold text-primary">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mt-2">{body}</p>
              </div>
              <div className="mt-5 text-xs uppercase tracking-[0.18em] text-leaf font-medium">0{i + 1} / 06</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
